module.exports = __webpack_public_path__ + "9c12322b.png";